import { useHandleErrorStatus } from "@/composable/useHandleErrorStatus";
import { http } from "@/composable/httpService";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useAssignToUsersStore = defineStore("assignTOUsersStore", () => {
  const users = ref([]);
  const loadingUsers = ref(false);
  const groups = ref([]);
  const loadingGroups = ref(false);
  const dealers = ref([]);
  const loadingDealers = ref(false);
  const companies = ref([]);
  const loadingCompanies = ref(false);
  const loadingRegions = ref(false);
  const regions = ref([]);

  const storePositionGroups = ref([]);
  const loadingStorePositionGroups = ref(false);


  const handleStorePositionGroups = async () => {
    try {
      loadingStorePositionGroups.value = true;
      const response = await http().get("/v3/store-position-groups");
      storePositionGroups.value = response.data;
    } catch (error) {
      useHandleErrorStatus(error);
    } finally {
      loadingStorePositionGroups.value = false;
    }
  }

  const handleFetchRegions = async (params) => {
    try {
      loadingRegions.value = true;
      const response = await http().get("/v3/regions", { params });
      regions.value = response.data;
    } catch (error) {
      useHandleErrorStatus(error);
    } finally {
      loadingRegions.value = false;
    }
  }
  const handleFetchUsers = async (params) => {
    try {
      loadingUsers.value = true;
      const response = await http().get("/client/lms/fetchUsersByDealer", {
        params,
      });
      users.value = response.data;
    } catch (error) {
      useHandleErrorStatus(error);
    } finally {
      loadingUsers.value = false;
    }
  };

  const handleFetchGroups = async (params) => {
    try {
      loadingGroups.value = true;
      const response = await http().get("/groups", { params });
      groups.value = response.data;
    } catch (error) {
      useHandleErrorStatus(error);
    } finally {
      loadingGroups.value = false;
    }
  };

  const handleFetchDealers = async (params) => {
    try {
      loadingDealers.value = true;
      const response = await http().get("/companies-and-dealers", { params });
      dealers.value = response.data?.data?.dealers;
    } catch (error) {
      useHandleErrorStatus(error);
    } finally {
      loadingDealers.value = false;
    }
  };

  const handleFetchCompanies = async (params) => {
    try {
      loadingCompanies.value = true;
      const response = await http().get("/companies-and-dealers", { params });
      companies.value = response.data?.data?.companies;
      dealers.value = response.data?.data?.dealers;
    } catch (error) {
      useHandleErrorStatus(error);
    } finally {
      loadingCompanies.value = false;
    }
  };

  return {
    handleFetchUsers,
    handleFetchGroups,
    handleFetchDealers,
    handleFetchCompanies,
    handleFetchRegions,
    handleStorePositionGroups,
    storePositionGroups,
    loadingStorePositionGroups,
    users,
    loadingUsers,
    companies,
    loadingCompanies,
    dealers,
    loadingDealers,
    regions,
    loadingRegions,
    groups,
    loadingGroups,
  };
});
